import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import AppRoutes from './routes';
import { RouteIsLoadingProvider } from './context/RouteIsLoadingContext';

function App() {
  return (
    <ThemeProvider>
      <RouteIsLoadingProvider>
        <Router>
          <AppRoutes />
        </Router>
      </RouteIsLoadingProvider>
    </ThemeProvider>
  );
}

export default App;
